<template>
    <div>
        <label v-if="field.type !== 'checkbox'" :for="field.internal_id" class="label">
            {{ field.label }}
            <span v-if="field.is_required" class="text-sm text-red-700">*</span>
        </label>

        <!-- Name, email and text fields -->
        <input
            v-if="field.type === 'text' || field.type === 'email' || field.type === 'name'"
            :type="[field.type === 'email' ? 'email' : 'text']"
            :name="field.internal_id"
            :id="field.internal_id"
            class="input"
            v-model="value"
            :required="field.is_required"
        />

        <!-- Phone -->
        <input
            v-if="field.type === 'phone'"
            type="tel"
            :name="field.internal_id"
            :id="field.internal_id"
            class="input"
            v-model="value"
            :required="field.is_required"
        />

        <!-- Textarea -->
        <textarea
            v-if="field.type === 'textarea'"
            :name="field.internal_id"
            :id="field.internal_id"
            cols="30"
            rows="5"
            v-model="value"
            class="input"
            :required="field.is_required"
        ></textarea>

        <!-- File inputs -->
        <input
            v-if="field.type === 'file'"
            type="file"
            :name="field.internal_id"
            :id="field.internal_id"
            @change="onFileChange"
            :required="field.is_required"
        />

        <!-- Dropdown menu -->
        <select
            v-if="field.type === 'select'"
            :name="field.internal_id"
            :id="field.internal_id"
            v-model="value"
            class="input"
            :required="field.is_required"
        >
            <option value="">{{ $t('Select an option') }}</option>
            <option :value="option" v-for="option in options">{{ option }}</option>
        </select>

        <!-- Checkbox -->
        <label v-if="field.type === 'checkbox'" class="flex items-center space-x-4">
            <input type="checkbox" :name="field.internal_id" :id="field.internal_id" v-model="value" :required="field.is_required" />

            <span>{{ field.label }}</span>
        </label>

        <p class="form-error" v-if="form.errors.has(field.internal_id)" v-text="form.errors.get(field.internal_id)"></p>
    </div>
</template>

<script>
    export default {
        props: {
            field: Object,
            modelValue: String,
        },

        data() {
            return {
                value: this.modelValue ?? '',
            };
        },

        computed: {
            form() {
                return this.$parent.form;
            },

            options() {
                if (this.field.metadata) {
                    let fields = this.field.metadata.split('\n');
                    return fields.map(f => f.trim()).filter(f => f.length);
                }

                return [];
            },
        },

        watch: {
            value() {
                this.$emit('update:modelValue', this.value);
            },
        },

        methods: {
            onFileChange(e) {
                this.value = e.target.files[0];
            },
        },
    };
</script>
